import type { RouteRecordRaw } from 'vue-router';

// /auctions = workspace-level index.
// /auctions/:id = lifecycle landing (draft/scheduled -> catalog,
// live -> run-live, closed -> reconcile-report).
export const routes: RouteRecordRaw[] = [
  {
    path: '/auctions',
    name: 'auctions-index',
    component: () => import('./pages/IndexPage.vue'),
    meta: {
      requiresAdminAuth: true,
      requiredRole: 'any',
      skipAuctionLoad: true,
    },
  },
  {
    path: '/auctions/:id',
    name: 'auction-landing',
    component: () => import('./pages/AuctionLandingRedirect.vue'),
    meta: { requiresAdminAuth: true, requiredRole: 'any' },
  },
];
